import { APP, Select, WithIcon } from '@advanza/advanza_generic'
import LicencesContainer from 'containers/LicencesContainer'
import React from 'react'

class LicencesSelect extends React.Component {
    componentDidMount() {
        this.props.fetchLicences()
    }

    render() {
        const { licenceIds, licences, ...rest } = this.props
        return (
            <Select
                multiple
                optionKeys={{
                    msgKey: 'abbreviation',
                    valueKey: 'licence_id',
                    nameKey: 'abbreviation',
                }}
                options={licenceIds.map((id) => licences[id])}
                {...rest}
            />
        )
    }
}

export default LicencesContainer(LicencesSelect)
